import React, { FunctionComponent, h } from "preact"; // eslint-disable-line @typescript-eslint/no-unused-vars

import cx from "classnames";

export interface IPaginationLink {
  title: string;
  type: "prev" | "page" | "next";
  page?: number;
  current?: boolean;
  rel?: string;
  handleChangePage: (page: number) => void;
}

const PaginationLink: FunctionComponent<IPaginationLink> = ({ page = 1, current, title, type, handleChangePage }) => {
  const onChangePage = (newPage: number) => () => {
    handleChangePage(newPage);
  };
  return (
    <button
      title={title}
      className={cx("pagination__link", `pagination__link--${type}`, {
        "pagination__link--active": current,
      })}
      onClick={onChangePage(page)}
    >
      {page}
    </button>
  );
};

export default PaginationLink;
